<script>
  import {getArticleURL} from '../DocumentLibrary/fresh-widget'

  export let item = {}


  $: dateTitle = item.status === 2 ? 'Last published:' : 'Created:'
  $: inTitle = item.category_name && item.folder_name ? item.category_name + ' / ' + item.folder_name : ''

  async function onClick (item) {
    const url = await getArticleURL(item)
    console.log('[DEBUG] target url', url)
    const win = window.open(url, '_blank')
    win.focus()
  }

</script>

<div class="flex">

  <div class="w-16 pl-1 flex-shrink-0 hidden sm:block" style="padding-top: 0.7rem">
    <svg xmlns="http://www.w3.org/2000/svg"
         data-name="Layer 2"
         viewBox="0 0 20 20"
         class="app-icon app-icon--large pull-left result-item__icon"
         data-identifyElement="191">
      <path d="M17.88 16.73a.7.7 0 01-.7.7h-2.83a5.92 5.92 0 00-3.43 1.08l-.52.36a.68.68 0 01-.8 0l-.52-.36a5.94 5.94 0 00-3.43-1.08H2.82a.7.7 0 010-1.4h2.83a7.37 7.37 0 014.23 1.33l.12.09.11-.08A7.33 7.33 0 0114.35 16h2.83a.7.7 0 01.7.73zM19 1.7v12.14a.7.7 0 01-.7.7h-4.51a6.07 6.07 0 00-3.4 1h-.15a.6.6 0 01-.48 0h-.15a6.07 6.07 0 00-3.4-1H1.7a.7.7 0 01-.7-.7V1.7a.7.7 0 01.7-.7h4.51A7.5 7.5 0 0110 2a7.5 7.5 0 013.79-1h4.51a.7.7 0 01.7.7zM6.21 13.14a7.47 7.47 0 013.09.67V3.25a6.11 6.11 0 00-3.09-.85H2.4v10.74zM17.6 2.4h-3.81a6.11 6.11 0 00-3.09.85v10.56a7.47 7.47 0 013.09-.67h3.81z" data-identifyElement="192"></path>
    </svg>
  </div>

  <div class="flex-grow">
    <div class="text-lg font-medium text-red-600 hover:underline" on:click={() => onClick(item)}>
        {item.title}
    </div>
    <div class="text-base text-gray-900 font-medium">In: {inTitle}</div>
    <div class="font-light">{item.description_text.substr(0, 500) + ' ...'}</div>
  </div>
</div>

<!--  https://flexlink.freshdesk.com/a/solutions/articles/35000158655?portalId=35000062767-->

<style>
  .app-icon {
      width: 2em;
      height: 2em;
  }
</style>